import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { LoginStore } from '../stores';

export const useLoginStore = () =>
  useContext<{
    loginStore: LoginStore;
  }>(StoreContext);
